import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withKeys as _withKeys, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "connection-bar__status" }
const _hoisted_2 = { class: "connection-bar__hint" }

import {
  NInput,
  NInputGroup,
  NSelect,
  NForm,
  NFormItem,
  NInputNumber,
  NSpace,
  NH3,
  NModal,
  useMessage,
} from 'naive-ui'

import { ref, computed } from 'vue'
import { useRouter } from 'vue-router'
import { useI18n } from 'vue-i18n'
import { useMqttStore } from '@/store/mqttStore'
import { usePositionStore } from '@/store/positionStore'
import { storeToRefs } from 'pinia'
import { BfButton, ButtonType, ButtonState } from '@finetic/bikefitting-ui'
import BikeStatus from '@/components/controls/BikeStatus.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'ConnectionBar',
  setup(__props) {

const router = useRouter()
const mqttStore = useMqttStore()
const positionStore = usePositionStore()
const message = useMessage()
const { t } = useI18n()

const {
  createConnection,
  destroyConnection,
  handleProtocolChange,
  discoverIPAddress,
} = mqttStore
const { resetPosition, startHoming } = positionStore
const { client, connection, connected, connecting, connectionError } =
  storeToRefs(mqttStore)

const macAddress = ref('')

const options = [
  {
    label: 'ws://',
    value: 'ws',
  },
  {
    label: 'wss://',
    value: 'wss',
  },
]

const showModal = computed({
  get() {
    return !connected.value && connectionError.value ? true : false
  },
  set(newValue) {
    if (newValue == false) {
      connectionError.value = ''
    }
  },
})

const connect = () => {
  createConnection()
  startHoming()
  resetPosition()

  router.push({ name: 'start' })
}

const discover = () => {
  discoverIPAddress(macAddress.value).then((data) => {
    if (data) {
      message.success(t('common.connection.discover.found'))
    } else {
      message.warning(t('common.connection.discover.noresult'))
    }
  })
}

const disconnect = () => {
  destroyConnection(client.value)

  router.push({ name: 'start' })
}

connect()

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(NSpace), {
      align: "center",
      justify: "space-between",
      class: "connection-bar",
      size: [16, 32],
      "wrap-item": false
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(NSpace), {
          align: "center",
          class: "connection-bar__info",
          "wrap-item": false
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(NH3), { class: "connection-bar__title" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(connected)
            ? _unref(t)('common.connection.fitbike')
            : _unref(t)('common.connection.connectFitbike')), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        (_unref(connected))
          ? (_openBlock(), _createBlock(_unref(NSpace), {
              key: 0,
              align: "center",
              size: 16
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_1, [
                  _createElementVNode("span", null, _toDisplayString(_unref(t)('common.connection.connected')), 1)
                ])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(_unref(NSpace), { class: "connection-bar__buttons" }, {
          default: _withCtx(() => [
            (!_unref(connected) && !showModal.value)
              ? (_openBlock(), _createBlock(_unref(BfButton), {
                  key: 0,
                  state: _unref(connecting) ? _unref(ButtonState).Loading : _unref(ButtonState).Enabled,
                  onClick: connect
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(connected)
            ? _unref(t)('common.connection.connected')
            : _unref(t)('common.connection.connect')), 1)
                  ]),
                  _: 1
                }, 8, ["state"]))
              : _createCommentVNode("", true),
            (_unref(connected))
              ? (_openBlock(), _createBlock(_unref(BfButton), {
                  key: 1,
                  type: _unref(ButtonType).Outlined,
                  onClick: disconnect
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('common.connection.disconnect')), 1)
                  ]),
                  _: 1
                }, 8, ["type"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    (_unref(connected))
      ? (_openBlock(), _createBlock(BikeStatus, { key: 0 }))
      : _createCommentVNode("", true),
    _createVNode(_unref(NModal), {
      show: showModal.value,
      "onUpdate:show": _cache[4] || (_cache[4] = ($event: any) => ((showModal).value = $event)),
      style: {"width":"600px"},
      class: "custom-card",
      preset: "card",
      title: _unref(t)('common.connection.failed.title'),
      bordered: false,
      size: "huge"
    }, {
      default: _withCtx(() => [
        (!_unref(connected))
          ? (_openBlock(), _createBlock(_unref(NForm), {
              key: 0,
              ref: "formRef",
              "label-placement": "top"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(NFormItem), {
                  label: _unref(t)('common.connection.protocolHostPort')
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(NInputGroup), {
                      class: "connection-bar__address",
                      onKeyup: _withKeys(_unref(createConnection), ["enter"])
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(NSelect), {
                          value: _unref(connection).protocol,
                          "onUpdate:value": [
                            _cache[0] || (_cache[0] = ($event: any) => ((_unref(connection).protocol) = $event)),
                            _unref(handleProtocolChange)
                          ],
                          options: options,
                          style: { width: '20%' },
                          disabled: _unref(connecting)
                        }, null, 8, ["value", "disabled", "onUpdate:value"]),
                        _createVNode(_unref(NInput), {
                          value: _unref(connection).host,
                          "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_unref(connection).host) = $event)),
                          style: { width: '60%' },
                          disabled: _unref(connecting)
                        }, null, 8, ["value", "disabled"]),
                        _createVNode(_unref(NInputNumber), {
                          value: _unref(connection).port,
                          "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_unref(connection).port) = $event)),
                          style: { width: '20%' },
                          "show-button": false,
                          disabled: _unref(connecting)
                        }, null, 8, ["value", "disabled"])
                      ]),
                      _: 1
                    }, 8, ["onKeyup"]),
                    (!_unref(connected))
                      ? (_openBlock(), _createBlock(_unref(BfButton), {
                          key: 0,
                          state: _unref(connecting) ? _unref(ButtonState).Loading : _unref(ButtonState).Enabled,
                          style: {"margin-left":"12px"},
                          onClick: connect
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_unref(connected)
              ? _unref(t)('common.connection.connected')
              : _unref(t)('common.connection.connect')), 1)
                          ]),
                          _: 1
                        }, 8, ["state"]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["label"]),
                _createVNode(_unref(NFormItem), {
                  label: _unref(t)('common.connection.discover.info'),
                  class: "connection-bar__discover"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(NInputGroup), {
                      class: "connection-bar__address",
                      onKeyup: _withKeys(discover, ["enter"])
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(NInput), {
                          value: macAddress.value,
                          "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((macAddress).value = $event)),
                          placeholder: _unref(t)('common.connection.discover.macaddress'),
                          disabled: _unref(connecting)
                        }, null, 8, ["value", "placeholder", "disabled"])
                      ]),
                      _: 1
                    }),
                    (!_unref(connected))
                      ? (_openBlock(), _createBlock(_unref(BfButton), {
                          key: 0,
                          state: _unref(connecting) ? _unref(ButtonState).Disabled : _unref(ButtonState).Enabled,
                          type: _unref(ButtonType).Outlined,
                          style: {"margin-left":"12px"},
                          onClick: discover
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_unref(t)('common.connection.discover.title')), 1)
                          ]),
                          _: 1
                        }, 8, ["state", "type"]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["label"])
              ]),
              _: 1
            }, 512))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("p", null, _toDisplayString(_unref(t)('common.connection.failed.content')), 1),
          _createElementVNode("ul", null, [
            _createElementVNode("li", null, _toDisplayString(_unref(t)('common.connection.failed.tip1')), 1),
            _createElementVNode("li", null, _toDisplayString(_unref(t)('common.connection.failed.tip2')), 1),
            _createElementVNode("li", null, _toDisplayString(_unref(t)('common.connection.failed.tip3')), 1)
          ])
        ])
      ]),
      _: 1
    }, 8, ["show", "title"])
  ], 64))
}
}

})